/**
 * @file Notifies the Domoscio SCORM package hosting the LXP that it must sync the learner's KPIs
 * (score, lesson_status) to the LMS.
 */

/** Legacy message: packages already deployed in LMSes compare `event.data == "commit"`. */
export const SCORM_COMMIT_MESSAGE = 'commit'

/**
 * Message carrying the Domoscio student uid for this KPI call. In the SSO flow (instance flag
 * `sso_login`), the student Hub runs for is the MQB / Okta user, not the LMS learner
 * (`cmi.core.student_id`).
 */
export type ScormSaveKpisMessage = {
  type: 'save-kpis'
  // eslint-disable-next-line camelcase
  student_uid: string
}

type PostScormCommitParams = {
  studentUid?: string | number | null
  isScorm?: boolean
}

/**
 * Post the KPI sync to the parent window (the SCORM package).
 * The LMS origin is not known by the LXP: '*'.
 *
 * @param studentUid Domoscio student uid (User context `uid`), used only for this call
 * @param isScorm Whether the LXP was launched from a SCORM package (`session.origin === 'scorm'`)
 */
export const postScormCommit = ({ studentUid, isScorm = false }: PostScormCommitParams = {}) => {
  if (typeof window === 'undefined' || !window.parent) return

  const hasStudentUid = studentUid !== undefined && studentUid !== null && studentUid !== ''

  if (isScorm && hasStudentUid) {
    const message: ScormSaveKpisMessage = { type: 'save-kpis', student_uid: String(studentUid) }
    window.parent.postMessage(message, '*')
  }

  window.parent.postMessage(SCORM_COMMIT_MESSAGE, '*')
}
